import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
    selector: '[appCustomAutofocus]',
    standalone: false
})
export class CustomAutofocusDirective implements OnInit {
  @Input('appCustomAutofocus') value: boolean;
  constructor(private elementRef: ElementRef<HTMLInputElement>) {}

  ngOnInit() {
    if (!this.value) {
      this.elementRef.nativeElement.setAttribute('tabindex', '-1');
      this.elementRef.nativeElement.style.outline = 'none';
    }
    this.elementRef.nativeElement.focus(); //use focus function instead of autofocus attribute to avoid cross browser problem. And autofocus should only be used to mark an element to be focused when page loads.
  }
}
